import { PROJECT_BRANDS } from '@/modules/brand/domain/brand';

export const getBrand = (state) => state.brand;

export const isReverseHealthBrand = (state) => state.brand === PROJECT_BRANDS.reverse;
